/// <reference path="../commons/common.js" />
/// <reference path="../commons/resources.js" />
/*
Client Bidder
#btnBid                                 : bottone offerta
[data-select="currency"]                : selettore della valuta
[data-display-history="list"]           : lista offerte
[data-display-offer="current"]          : offerta corrente
[data-display-offer="value"]            : offerta corrente valore
[data-display-offer="symbol"]           : offerta corrente simbolo
[data-display-offer="converted"]        : pannello cambio valuta offerta
[data-display-offer="converted-value"]  : offerta corrente valore
[data-display-offer="converted-symbol"] : offerta corrente simbolo
[data-display-lot="list"]               : la lista dei lotti
[data-display-lot="current"]            : lotto corrente
[data-display-lot="image"]              : immagine del lotto corrente
[data-display-lot="number"]             : numero del lotto corrente
[data-display-lot="title"]              : titolo del lotto correntea
[data-display-lot="description"]        : descrizione del lotto corrente
[data-display-lot="info"]               : other info
#lot-id                                 : id lotto corrente nella lista
 */

/* 
Object Status Fields:
    AuctionID
    AuctionStatus
    CurrentDeskValue
    CurrentOfferChannel
    CurrentOfferID
    CurrentOfferIsAutoRaised
    CurrentOfferType
    CurrentOfferUserID
    CurrentOfferValue
    HasBestOffer
    HasPendingOffer
    IsFairWarning
    LiveLotsSellableCount    
    LotID
    LotNumber
    LotStatus
    NewOfferChannel
    NewOfferID
    NewOfferIsAutoRaised
    NewOfferUserID
    NewOfferValue
    NextLotID
    NextStep
    NextSteps
    ServerTime
    SessionID
    SessionStatus
    StartPrice
    ThereAreLotsSellable
 */
'use strict';

//import { setTimeout } from "timers";
//import { fail } from "assert";

var bidder = bidder || {};

bidder.IMAGE_DEFAULT = '/Commons/img/logo.png';
bidder.DESCRIPTION_CHARS = 250;
bidder.NotificationTimeout = 5 * 1000;
bidder.ExchangeRate = {};

var BidderClient = function () {

    this.settings = {};
    this.options = {};
    this.status = {};
    this.lotsStatus = [];
    this.lotID = 0;
    this.isFairWarning = false;
    this.lotCurrentOfferID = null;
    this.lastMessage = null;
    this.stopTryReconnection = false;
    this.player = null;
    this.exchangeService = null;
    this.currencyExchangeRatio = 1;
    this.offerID = null;
    this.newOfferID = null;
    this.lotExpiration = null;

    //session timer
    this.sessionTimerStartTime = null;
    //show lot timer
    this.showLotTimer = null;
    this.showLotStart = null;
    this.showLotInterval = 1000; //1 sec
}

BidderClient.prototype = {
    init: function (config, options, exchangeService, resourceService) {

        config = config || {};
        options = options || {};

        var self = this;

        var defaultsConfig = {
            auctionID: 0,
            auctionCode: null,
            siteID: 0,
            houseID: 0,
            cobrandingID: null,
            userID: null,
            bidderCode: null,
            bidderCurrency: null,
            bidderType: null,
            bidEnable: null,
            bidderAuthStatus: null,
            bidderLang: bidder.LANGUAGE_DEFAULT,
            bidderCountry: bidder.COUNTRY_DEFAULT,
            bidderTimezone: null,
            clientIPAddress: null,
            sessionToken: null,
            maxOfferLots: null,
            maxOfferAuction: null,
            useToastr: true,
        };

        $.extend(self.settings, defaultsConfig, config);

        var defaultsOptions = {
            auctionCurrency: bidder.CURRENCY_CODE_DEFAULT,
            auctionTimezone: null,
            houseCountry: bidder.COUNTRY_DEFAULT,
            houseCurrency: bidder.CURRENCY_CODE_DEFAULT,
            houseTimezone: null,
            containerID: '',
            loginURL: null,
            registrationURL: null,
            userProfileURL: null,
            registerToAuctionURL: null,
            reconnectionTimeout: 5 * 1000,
            isAutomatic: null,
            closingDelayTime: 1000,
            lotShowTime: null,
            bidDelayTime: null,
            fairWarningTime: null,
            historyOrder: 0, // 0 = ultimi in cima, >= 1 ultimi in fondo
        };

        $.extend(self.options, defaultsOptions, options);

        if (self.settings.useToastr) {
            toastr.options = {
                timeOut: bidder.NotificationTimeout,
                positionClass: 'toast-top-center',
                preventDuplicates: true
            };
        }

        var exchangeLoaded = exchangeService.load().then(function (data) {
            console.log('currencies loaded', data);
            bidder.ExchangeRate = data;

            //override user default value with house currency
            self.changeCurrency(self.options.auctionCurrency);

            //add bidder currency listener
            $('[data-select="currency"]').on('change', $.proxy(self.currencyChanged, self));

            //set user default value
            self.changeCurrency(self.settings.bidderCurrency);

            //retrieve the currency symbol
            if (bidder.currencies[self.options.auctionCurrency]) {
                bidder.CURRENCY_SYMBOL = bidder.currencies[self.options.auctionCurrency];
            } else {
                bidder.CURRENCY_SYMBOL = bidder.CURRENCY_SYMBOL_DEFAULT;
            }
        });

        var resourceLoaded = resourceService.load().then(function (resources) {
            console.log('resources loaded', resources);

            self.resources = resources;
        });

        $.when(exchangeLoaded, resourceLoaded).done(function () {
            initHub();
            initUI();
        });

        function initHub() {

            $.connection.bidderHub.client.onJoined = function (status, lotsStatus) {
                console.log('onJoined', status);

                self.updateLotsStatus(lotsStatus);  //update all lots
                self.updateStatus(status);   //update current status              
            };

            //sync lot expiratation
            $.connection.bidderHub.client.onSyncLotTimeoutExpiration = function (lotID, expiration) {
                //console.log("onSyncLotTimeoutExpiration", lotID, expiration);
                self.lotExpiration = expiration;
                if (self.lotID == lotID && self.status.LotStatus == bidder.LotStatus.Sellable.value) {
                    //$("#lot-timer [data-expiration]").text(String.toMMSS(Math.max(0, expiration - self.options.closingDelayTime) / 1000));
                    $("#lot-timer [data-expiration]").text(String.toMMSS(Math.max(0, self.lotExpiration) / 1000));
                    if (self.lotExpiration < self.options.closingDelayTime) {
                        self.setBidButtonDisabled(true);
                        self.setBidButton(self.resources.ButtonWaitingForAward, bidder.ButtonStyle.Disabled.name);
                    }
                }
            };

            //session start
            $.connection.bidderHub.client.onSessionStarted = function () {
                self.showMessage(self.resources.AuctionSessionStarted, bidder.LogType.Success, null, null);
                self.addHistory(self.resources.AuctionSessionStarted, bidder.HistMsgType.Normal);
            };

            //session stop
            $.connection.bidderHub.client.onSessionEnded = function (nextSessionID) {
                console.log("onSessionEnded - Next SessionID: ", nextSessionID);
                if (!nextSessionID) {
                    self.stopConnection();
                } else {
                    //todo: refresh con il nuovo ID window.location.href = ""
                }
            };

            //on lot changing (future usage)
            $.connection.bidderHub.client.onLotChanging = function (nextLotID) {
                console.log("OnLotChanging", nextLotID);
            };

            //update status
            $.connection.bidderHub.client.onUpdateStatus = function (status) {
                self.updateStatus(status);
            };

            //update all lots
            $.connection.bidderHub.client.onUpdateLotsStatus = function (lotsStatus) {
                //update all lots
                self.updateLotsStatus(lotsStatus);
            };

            //update single lot
            $.connection.bidderHub.client.onUpdateSingleLotStatus = function (lotStatus) {
                console.log('OnUpdateSingleLotStatus', lotStatus);
                //update single lot
                self.updateSingleLotStatus(lotStatus);
            }

            //notify overtaken
            $.connection.bidderHub.client.onNotifyOvertaken = function (lotID) {
                console.log('onNotifyOvertaken', lotID);
                if (self.lotID == lotID) {
                    self.showMessage(self.resources.NotifyOvertaken, bidder.LogType.Warning, null, null);
                    self.addHistory(self.resources.NotifyOvertaken, bidder.HistMsgType.Normal);
                }
            };

            $.connection.bidderHub.client.onNotifyUserOfferNotAccepted = function (lotID) {
                console.log('onNotifyUserOfferNotAccepted', lotID);
                if (self.lotID == lotID) {
                    self.showMessage(self.resources.NotifyOfferNotAccepted, bidder.LogType.Warning, null, null);
                    self.addHistory(self.resources.NotifyOfferNotAccepted, bidder.HistMsgType.Normal);
                }
            };

            //notify offer cancelled and back to prev offer
            $.connection.bidderHub.client.onBackToPrevOffer = function (lotID, isCurrentBestOffer, isPrevBestOffer) {
                console.log('onBackToPrevOffer', lotID, isCurrentBestOffer, isPrevBestOffer);
                if (self.lotID == lotID) {
                    self.showMessage(self.resources.LastOfferCancelled, bidder.LogType.Warning, null, null);
                    self.addHistory(self.resources.LastOfferCancelled, bidder.HistMsgType.Normal);
                }
            }

            //notify lot reopened
            $.connection.bidderHub.client.onLotReopened = function (lotID, owner) {
                console.log('onLotReopened', lotID);
                if (!owner) {
                    //generic message
                    self.showMessage(self.resources.ReopenLot, bidder.LogType.Error, null, null);
                    self.addHistory(self.resources.ReopenLot, bidder.HistMsgType.Warning);
                } else {
                    //custom message for winner
                    self.showMessage(self.resources.ReopenLotYouWon, bidder.LogType.Error, null, null);
                    self.addHistory(self.resources.ReopenLotYouWon, bidder.HistMsgType.Warning);
                }
            };

            $.connection.bidderHub.client.onFairWarnigChanged = function (lotID, isFairwarning) {
                //console.log("onFairWarnigChanged", lotID, isFairwarning);
                if (self.lotID == lotID) {
                    if (isFairwarning) {
                        self.showFairWarning();
                    } else {
                        self.hideFairWarning();
                    }
                    self.isFairWarning = isFairwarning;
                } else {
                    self.isFairWarning = false;
                }
            };

            $.connection.bidderHub.client.onErrorMessage = function (message) {
                console.log('onErrorMessage', message);
                if (message) {
                    self.showMessage(message, bidder.LogType.Error, null, null);
                    self.addHistory(message, bidder.HistMsgType.Warning);
                }
            };

            $.connection.bidderHub.client.onMessage = function (message, temporary, type) {
                console.log('onMessage', message, type);
                type = type || 'info';
                var logType = bidder.findByValue(bidder.LogType, type);
                self.showMessage(message, logType, null, temporary ? bidder.NotificationTimeout : 0);
                self.addHistory(message, bidder.HistMsgType.Normal);
            };

            //restart client
            $.connection.bidderHub.client.onRestartClient = function () {
                console.log('restart client');
                restartConnection();
            };

            $.connection.bidderHub.client.onStopClient = function () {
                console.log('stop client');
                self.stopConnection();
            };

            //$.connection.bidderHub.client.stopClient = function () {
            //    console.log('stop client');
            //    self.stopConnection();
            //};

            $.connection.hub.stateChanged(function connectionStateChanged(state) {
                var newState = bidder.findByValue(bidder.ConnectionStatus, state.newState);
                var oldState = bidder.findByValue(bidder.ConnectionStatus, state.oldState);
                //todo show status: newState.name, oldState.name
            });

            $.connection.hub.connectionSlow(function () {
                console.log('connection slow');
            });

            $.connection.hub.reconnecting(function () {
                console.log('reconnecting');
            });

            $.connection.hub.reconnected(function () {
                console.log('reconnected');
                onConnectionStarted();
            });

            // continuously reconnect
            $.connection.hub.disconnected(function () {
                console.log('disconnected');
                restartConnection();
            });

            function restartConnection() {
                console.log('restartConnection');
                if (!self.stopTryReconnection) {
                    // Restart connection after 5 seconds.
                    setTimeout(function () {
                        console.log('try connecting...');
                        $.connection.hub.start().then(onConnectionStarted);
                    }, self.options.reconnectionTimeout);
                }
            }

            console.log('start hub connection ...', self.settings);
            $.connection.hub.start().then(onConnectionStarted);

            function onConnectionStarted() {
                console.log('hub connected. Joining ...', self.settings);
                $.connection.bidderHub.server.bidderJoin(self.settings);
            }
        }

        function initUI() {
            if (self.settings.bidEnable == bidder.BOOL_TRUE) {
                //bid handlers
                $(self.options.containerID).on('click', '#btnBid', $.proxy(self.sendBid, self));
                $(self.options.containerID).on('mouseenter mouseleave', '#btnBid', $.proxy(self.bidButtonMouseHover, self));
            } else {
                //remove all delegated click handlers from container
                $(self.settings.containerID).off('click', '**');
                self.configureAlternativeButton();
            }

            // start history list from bottom
            var historyList = document.querySelector('[data-display-history="list"]');
            historyList.scrollTop = historyList.scrollHeight;
            $('[data-display-lot="list"]').on('click', '.item', function (e) {
                $('#image-preview').attr('src', $(this).data('image-md'));
                $('#modal-label-preview').html($(this).data('lot-number'))
                $('#zoom-title').html($(this).data('title'));
                var desc = '<p>' + $(this).data('description') + '</p><a class="lotbutton" href="' + $(this).data('lot-url') + '" target="_blank">' + self.resources.ViewLotDetail + '</a>'
                $('#zoom-description').html(desc)
                $('#zoom-startprice').html('<strong>' + self.resources.StartPrice + ': ' + parseFloat($(this).data('start-price')) + ' ' + bidder.CURRENCY_SYMBOL + '</strong>')

                $('#imagemodal').modal('show');
            });
        }

    },
    refreshLotDetails: function () {
        var self = this;

        if (self.options.isAutomatic == bidder.BOOL_TRUE) {
            $("#lot-timer label").text(self.resources.AutomaticExpirationLabel);
            $("#lot-timer").show();
            $("#lot-timer [data-expiration]").text(String.toMMSS(self.options.lotShowTime / 1000));
        }

        //set new current
        $('[data-display-lot="list"] div').removeClass('current');
        var lotData = $('#lot-' + self.lotID).addClass('current');
        $('#lot-' + self.lotID).find('.caption').html(lotData.data("lot-number") + ' - ' + self.resources.CurrentLotLabel);
        // show data in the main box            
        //$('[data-display-lot="current"]').data('lot-number', lotData.data('lot-number'));
        $('[data-display-lot="current"]').data('index', lotData.data('index'));
        $('[data-display-lot="number"]').html("<strong>" + lotData.data("lot-number") + "</strong>&nbsp;:");
        $('[data-display-lot="image"]').attr('src', lotData.data('image-lg'));
        $('[data-display-lot="title"]').html(lotData.data('title'));
        $('[data-display-lot="info"]').html('<strong>' + self.resources.StartPrice + ': ' + parseFloat(lotData.data('start-price')) + ' ' + bidder.CURRENCY_SYMBOL + '</strong>');

        var desc = lotData.data('description');

        $('[data-display-lot="description"]').html('<p>' + desc + '</p><a href="' + lotData.data('lot-url') + '" target="_blank" class="lotbutton">' + self.resources.ViewLotDetail + '</a>');

        //estimation
        var estimationMin = parseFloat(lotData.data('min-estimation')),
            estimationMax = parseFloat(lotData.data('max-estimation'));

        if (estimationMin >= 0 && estimationMax > estimationMin) {
            $('[data-display-lot="estimation"]').html('<span>' + self.resources.Estimation + ': ' + estimationMin + ' - ' + estimationMax + ' ' + bidder.CURRENCY_SYMBOL + '</span>');
        } else if (estimationMin >= 0) {
            $('[data-display-lot="estimation"]').html('<span>' + self.resources.Estimation + ': ' + estimationMin + ' ' + bidder.CURRENCY_SYMBOL + '</span>');
        } else if (estimationMax >= 0) {
            $('[data-display-lot="estimation"]').html('<span>' + self.resources.Estimation + ': ' + estimationMax + ' ' + bidder.CURRENCY_SYMBOL + '</span>');
        } else {
            $('[data-display-lot="estimation"]').html('');
        }

        //show progress bar indicator
        var index = parseInt($('[data-display-lot="current"]').data('index'));
        //save data in hidden fields
        $('#hid-lot-index').val($('[data-display-lot="current"]').data('index'));
        var total = parseInt($('#hid-lot-count').val());

        $('.bidding-status').html(String.format(self.resources.LotProgressBidder, (index + 1), total));
        $('.progress-bar').attr('aria-valuemax', total);
        $('.progress-bar').attr('aria-valuenow', index + 1);
        $('.progress-bar').css('width', ((index + 1) / total * 100) + '%');

        // scroll list to show current lot index
        var $owlbidlist = $('.owl-imgs');
        $owlbidlist.trigger('to.owl.carousel', index);

        self.addHistory(self.resources.OpenLot, bidder.HistMsgType.NewLot);

        self.dispatch('bidder:new-lot', {
            bubbles: true,
            cancelable: false,
            detail: {
                instance: self
            }
        })

    },
    refreshLotOfferLabelAndValue: function (offerLabel, offerValue) {
        var self = this;

        $('[data-display-offer="current"] label').html(offerLabel);
        $('[data-display-offer="current"] [data-display-offer="value"]').html(self.formatOfferValue(offerValue, 0));
        $('[data-display-offer="current"] [data-display-offer="symbol"]').html(bidder.CURRENCY_SYMBOL);
    },
    refreshBidButton: function () {
        var self = this;
        //Update Button - Start
        if (self.settings.bidEnable == bidder.BOOL_TRUE && self.settings.userID != null) {

            // --- user can bid ---

            //default button text
            var buttonText = self.resources.ButtonOffer + " " +
                self.formatOfferValue(self.status.NextStep, 0) + " " +
                bidder.CURRENCY_SYMBOL;

            var onHoverButtonText = self.resources.ButtonOffering + " " +
                self.formatOfferValue(self.status.NextStep, 0) + " " +
                bidder.CURRENCY_SYMBOL;

            var buttonEnabled = true;
            var buttonStyle = bidder.ButtonStyle.Enabled;
            var bidValue = self.status.NextStep;

            if (self.status.NewOfferID && self.status.NewOfferUserID == self.settings.userID) {
                //Your offer is pending and you must wait hall decision
                buttonText = self.resources.ButtonWaiting;
                onHoverButtonText = null;
                buttonEnabled = false;
            }

            if (self.status.DeskOfferUserID == self.settings.userID &&
                self.status.DeskOfferValue > self.status.NewOfferValue &&
                self.status.DeskOfferValue > self.status.CurrentOfferValue) {
                //Your desk offer is best offer
                buttonText = self.resources.ButtonWaiting;
                onHoverButtonText = null;
                buttonEnabled = false;
            }

            var lotStatusName = bidder.findByValue(bidder.LotStatus, self.status.LotStatus).name;
            //sold
            if (self.status.LotStatus == bidder.LotStatus.Sold.value) {
                buttonText = self.resources.ButtonLot + " " + self.resources.LotStatus[lotStatusName];
                onHoverButtonText = null;
                buttonEnabled = false;
            }
            //unsold, nodata, retired
            if (self.status.LotStatus == bidder.LotStatus.Unsold.value
                || self.status.LotStatus == bidder.LotStatus.NoData.value
                || self.status.LotStatus == bidder.LotStatus.Retired.value) {
                buttonText = self.resources.ButtonLot + " " + self.resources.LotStatus[lotStatusName];
                onHoverButtonText = null;
                buttonEnabled = false;
            }

            if (self.status.CurrentOfferUserID == self.settings.userID) {
                if (self.status.LotStatus == bidder.LotStatus.Sellable.value) {

                    if (self.status.CurrentOfferValue >= self.status.NewOfferValue || self.status.CurrentDeskValue >= self.status.NewOfferValue) {
                        //you are the best offer                        
                        buttonText = self.resources.ButtonBestOffer;
                        onHoverButtonText = null;
                        buttonEnabled = false;
                        buttonStyle = bidder.ButtonStyle.Best;
                    }

                } else if (self.status.LotStatus == bidder.LotStatus.Sold.value) {
                    //you are the lot's winner
                    buttonText = self.resources.ButtonWinLot;
                    onHoverButtonText = null;
                    buttonEnabled = false;
                    buttonStyle = bidder.ButtonStyle.Winner;
                }
            }

            //set button status, style and text
            self.setBidButtonDisabled(!buttonEnabled);
            self.setBidButton(buttonText, buttonStyle.name, self.status.LotID, bidValue, onHoverButtonText);
        } else {
            //--- user can't bid ---
            self.configureAlternativeButton();
        }
    },
    refreshHistoryCommon: function () {
        var self = this;

        if (self.status.LotStatus == bidder.LotStatus.Sellable.value) {

            //check if new offers arrive (pending) or if there is a current offer (confirmed) or if there aren't any offers
            if (self.status.CurrentOfferID || self.status.NewOfferID) {

                //show only offer confirmed from Hall because other offer are already shown
                if (self.status.CurrentOfferID) {
                    self.refreshLotOfferLabelAndValue(self.resources.CurrentOfferLabel, self.status.CurrentOfferValue);

                    if (self.status.CurrentOfferID != self.offerID) {
                        var offerChannel = bidder.findByValue(bidder.OfferChannel, self.status.CurrentOfferChannel);
                        if (self.status.CurrentOfferChannel == bidder.OfferChannel.Hall.value) {
                            self.addHistory(self.resources.Offer + " " + self.resources.OfferChannel[offerChannel.name] + " " +
                                (self.status.CurrentOfferIsAutoRaised ? self.resources.AutoRelaunchShortLabel + " " : "") +
                                self.formatOfferValue(self.status.CurrentOfferValue, 0) + " " + bidder.CURRENCY_SYMBOL,
                                bidder.HistMsgType.Offer);
                        }
                    }
                }

                //new pending offer from WEB
                if (self.status.NewOfferID) {
                    self.refreshLotOfferLabelAndValue(self.resources.CurrentOfferLabel, self.status.NewOfferValue);

                    if (self.status.NewOfferID != self.newOfferID) {
                        //if this is a new pending offer (!= self.newOfferID) find the source channel
                        var offerChannel = bidder.findByValue(bidder.OfferChannel, self.status.NewOfferChannel);

                        if (self.settings.userID && self.status.NewOfferUserID == self.settings.userID) {
                            //my pending offer
                            self.addHistory(self.resources.MyNewOffer + " " +
                                self.formatOfferValue(self.status.NewOfferValue, 0) + " " + bidder.CURRENCY_SYMBOL,
                                bidder.HistMsgType.MyOffer);
                        } else {
                            //ok someone else has made the offer
                            self.addHistory(self.resources.Offer + " " + self.resources.OfferChannel[offerChannel.name] + " " +
                                (self.status.NewOfferIsAutoRaised ? self.resources.AutoRelaunchShortLabel + " " : "") +
                                self.formatOfferValue(self.status.NewOfferValue, 0) + " " + bidder.CURRENCY_SYMBOL,
                                bidder.HistMsgType.Offer);
                        }
                    }
                }

            } else {
                //lot without offer
                var startPrice = self.status.StartPrice;
                if (self.status.NextStep < self.status.StartPrice) {
                    //the start price has been descreased
                    startPrice = self.status.NextStep;
                    self.addHistory(self.resources.StartPriceReduced, bidder.HistMsgType.Warning)
                }
                self.refreshLotOfferLabelAndValue(self.resources.StartPriceLabel, startPrice);
            }
        } else {
            //if lot is closed update history and show messages
            var lotStatusName = bidder.findByValue(bidder.LotStatus, self.status.LotStatus).name;
            if (self.status.LotStatus == bidder.LotStatus.Sold.value) {
                //self.status.CurrentOfferValue
                self.addHistory(self.resources.Lot + " " + self.resources.LotStatus[lotStatusName] + " " +
                    self.resources.ToLabel + " " +
                    self.formatOfferValue(self.status.CurrentOfferValue, 0) + " " + bidder.CURRENCY_SYMBOL,
                    bidder.HistMsgType.LotSold);
                self.showLotCloseStatus(self.resources.Lot + " " + self.resources.LotStatus[lotStatusName], bidder.LogType.Success);
            }
            if (self.status.LotStatus == bidder.LotStatus.Unsold.value) {
                self.addHistory(self.resources.Lot + " " + self.resources.LotStatus[lotStatusName], bidder.HistMsgType.LotUnsold);
                self.showLotCloseStatus(self.resources.Lot + " " + self.resources.LotStatus[lotStatusName], bidder.LogType.Info);
            }
            if (self.status.LotStatus == bidder.LotStatus.Retired.value) {
                self.addHistory(self.resources.LotRetired, bidder.HistMsgType.Normal);
                self.showLotCloseStatus(self.resources.Lot + " " + self.resources.LotStatus[lotStatusName], bidder.LogType.Info);
            }
            if (self.status.LotStatus == bidder.LotStatus.NoData.value) {
                self.addHistory(self.resources.LotClosed, bidder.HistMsgType.Normal);
                self.showLotCloseStatus(self.resources.LotClosed, bidder.LogType.Info);
            }
        }
    },
    refreshHistoryCustom: function () {
        var self = this;

        if (self.settings.bidEnable == bidder.BOOL_TRUE && self.settings.userID) {
            if (self.status.CurrentOfferUserID == self.settings.userID) {
                if (self.status.CurrentOfferID != self.offerID &&
                    self.status.LotStatus == bidder.LotStatus.Sellable.value) {
                    console.log(self.status.CurrentOfferValue, self.status.NewOfferValue, self.status.CurrentOfferValue >= self.status.NewOfferValue);
                    if (self.status.CurrentOfferValue >= self.status.NewOfferValue) {
                        //you are the current best offer
                        self.addHistory(self.resources.BestOfferMessage + " " +
                            self.formatOfferValue(self.status.CurrentOfferValue, 0) + " " + bidder.CURRENCY_SYMBOL,
                            bidder.HistMsgType.MyOffer);
                    }
                }
                if (self.status.LotStatus == bidder.LotStatus.Sold.value) {
                    //you won the lot
                    self.addHistory(self.resources.CongratulationsMessage,
                        bidder.HistMsgType.MyOffer);
                }
            }
        }
    },
    refreshSessionTimer: function () {
        var self = this;

        var remainingTime = new Date(self.options.startDate) - new Date();

        if (isNaN(remainingTime)) {
            $("#lot-timer").hide();
            return;
        }

        //console.log("refreshSessionTimer", new Date(self.options.startDate), new Date(), remainingTime);

        if (self.status.SessionStatus == bidder.SessionStatus.Ready.value && remainingTime >= 0) {
            $("#lot-timer [data-expiration]").text(String.toMMSS(remainingTime / 1000));
            setTimeout($.proxy(self.refreshSessionTimer, this), 1000);
        } else {
            /*$("#lot-timer").hide();*/
            $("#lot-timer [data-expiration]").text(String.toMMSS(0));
        }
    },
    updateStatus: function (status) {

        console.log('updated status: ', status);

        var self = this;
        self.status = status;

        self.setBidButtonDisabled(true);

        //Auction is not published or session is closed or in draft
        if (self.status.AuctionStatus != bidder.AuctionStatus.Published.value ||
            self.status.SessionStatus == bidder.SessionStatus.Draft.value ||
            self.status.SessionStatus == bidder.SessionStatus.Closed.value) {
            $('[data-display-offer="current"]').hide();
            self.stopConnection();
            return;
        }

        //Session is ready to start
        if (self.status.SessionStatus == bidder.SessionStatus.Ready.value) {
            $('[data-display-offer="current"]').hide();
            self.setBidButton(self.resources.ButtonWaitingAuctionStart, bidder.ButtonStyle.Disabled.name);
            self.addHistory(self.resources.AuctionWaitingMessage, bidder.HistMsgType.NewLot);
            self.showMessage(self.resources.AuctionWaitingMessage, bidder.LogType.Success, null, null);
            if (self.settings.bidEnable != bidder.BOOL_TRUE) {
                self.configureAlternativeButton();
            }

            if (self.options.isAutomatic == bidder.BOOL_TRUE && self.options.startTimeDelta > 0) {
                //check start time interval
                $("#lot-timer label").text(self.resources.AutomaticSessionStartInterval);
                $("#lot-timer").show();
                $("#lot-timer [data-expiration]").text(String.toMMSS(self.options.startTimeDelta / 1000));
                self.sessionTimerStartTime = new Date().getTime();
                setTimeout($.proxy(self.refreshSessionTimer, this), 1000);
            }
            return;
        }

        //Lots are finished
        if (!self.status.LotID && self.status.SessionStatus == bidder.SessionStatus.Live.value) {
            //status live and no current lot -> sellable lots are finished
            self.setBidButton(self.resources.ButtonWaiting, bidder.ButtonStyle.Disabled.name);
            return;
        }

        //show current offer only if session is started
        $('[data-display-offer="current"]').show();

        //check lot is changed
        if (self.lotID != self.status.LotID) {

            //lot changed
            console.log('lot changed', self.lotID, self.status.LotID);

            self.lotID = self.status.LotID;
            if (self.options.isAutomatic == bidder.BOOL_TRUE) {
                //reset lot expiration
                self.lotExpiration = self.options.lotShowTime;
            }

            self.clearLotDetails();

            self.refreshLotDetails();
        }

        //History updates
        self.refreshHistoryCommon();

        //custom message
        self.refreshHistoryCustom();

        //Bid button
        self.refreshBidButton();

        //update
        self.offerID = self.status.CurrentOfferID;
        self.newOfferID = self.status.NewOfferID;

        //refresh currency convertions
        self.refreshCurrencyConvertion();
    },
    updateLotsStatus: function (list) {
        //console.log('updateLotsStatus', list);
        var self = this;
        self.lotsStatus = list;
        for (var i = 0; i < list.length; i++) {
            self.refreshLotStatus(list[i]);
        }
    },
    bidButtonMouseHover: function (e) {
        var self = this;
        var isInside = e.type === 'mouseenter';

        if (isInside && $('#btnBid').data('onhover-text') && !$('#btnBid').prop("disabled")) {
            // change text
            $('#btnBid .text').html($('#btnBid').data('onhover-text'));
        } else {
            // resume text
            $('#btnBid .text').html($('#btnBid').data('default-text'));
        }
        self.refreshCurrencyConvertion();
    },
    updateSingleLotStatus: function (item) {
        var self = this;
        //console.log('Update single lot status', item);
        if (item && self.lotsStatus) {
            var indexes = $.map(self.lotsStatus, function (obj, index) {
                if (obj.LotID == item.LotID) {
                    return index;
                }
            });
            if (indexes.length == 1) {
                //update single item
                self.lotsStatus[indexes[0]] = item;
                self.refreshLotStatus(item);
            }
        }
    },
    getLotByID: function (lotID) {
        var self = this;
        var list = $.grep(self.lotsStatus, function (obj, index) {
            return obj.LotID == lotID;
        });
        return list[0];
    },
    refreshLotStatus: function (item) {
        //refresh status, winner and awarding price
        var self = this;
        var $currentLot = $('#lot-' + item.LotID);
        var status = bidder.findByValue(bidder.LotStatus, item.Status);
        $currentLot.removeClass(bidder.LotStatus.Join()).addClass(status.name);

        $currentLot.data('lot-status', status.name);
        $currentLot.data('lot-price', item.Price);
        $currentLot.data('lot-winner-id', item.WinnerID);
        if (status.value == bidder.LotStatus.Sellable.value) {
            $currentLot.find('.caption').html(item.Number);
        } else {
            //display lot status
            $currentLot.find('.caption').html(item.Number + ' - ' + self.resources.LotStatus[status.name]);
        }
    },
    clearLotDetails: function () {
        var self = this;

        //reset history
        $('[data-display-history="list"]').empty();
        //reset offer value
        $('[data-display-offer="current"] [data-display-offer="value"]').html('-');
        $('[data-display-offer="current"] [data-display-offer="symbol"]').html('-');

        $('[data-display-lot="current"]').data('lot-number', '').data('lot-index', '');
        $('[data-display-lot="number"]').html('');
        $('[data-display-lot="image"]').attr('src', bidder.IMAGE_DEFAULT);
        $('[data-display-lot="title"]').html('');
        $('[data-display-lot="description"]').html('');
        $('[data-display-lot="info"]').html('');
    },
    sendBid: function (e) {
        e.preventDefault();

        var self = this;

        console.log('lotExpiration', self.lotExpiration, self.options.closingDelayTime);

        if (self.options.isAutomatic == bidder.BOOL_TRUE &&
            self.options.closingDelayTime > 0 &&
            self.lotExpiration < self.options.closingDelayTime) {

            return;
        }

        self.setBidButton(self.resources.ButtonSending, bidder.ButtonStyle.Disabled.name);
        self.setBidButtonDisabled(true);

        var lotID = parseInt($('#btnBid').data('lotID'));
        var value = parseFloat($('#btnBid').data('nextStep'));

        if (lotID == self.lotID && value == self.status.NextStep) {
            $.connection.bidderHub.server.placeBid(self.settings, self.lotID, self.status.NextStep);
        }
    },
    changeCurrency: function (code) {
        if ($('[data-select="currency"] option[value="' + code + '"]').val()) {
            $('[data-select="currency"]').val(code);
        }
    },
    currencyChanged: function (e) {
        e.preventDefault();

        var self = this;

        self.settings.bidderCurrency = $('[data-select="currency"]').val();

        self.refreshCurrencyConvertion();
    },
    refreshCurrencyConvertion: function () {
        var self = this;

        if (self.settings.bidderCurrency != self.options.auctionCurrency && bidder.ExchangeRate[self.settings.bidderCurrency]) {

            self.currencyExchangeRatio = bidder.ExchangeRate[self.settings.bidderCurrency];
            //console.log("currency conversion: 1", self.options.currency, self.formatOfferValue(self.currencyExchangeRatio, 2), self.settings.bidderCurrency);
            var currentPrice = Math.min(self.status.StartPrice, self.status.NextStep);
            if (self.status.CurrentOfferID) {
                currentPrice = self.status.CurrentOfferValue;
            }
            //if exists with take the pending offer
            if (self.status.NewOfferID) {
                currentPrice = self.status.NewOfferValue;
            }
            var currentPriceConvValue = currentPrice * self.currencyExchangeRatio;

            $('[data-display-offer="converted"] [data-display-offer="converted-value"]').html(self.formatOfferValue(currentPriceConvValue, 2));
            $('[data-display-offer="converted"] [data-display-offer="converted-symbol"]').html(self.settings.bidderCurrency);
            $('[data-display-offer="converted"]').show();

            if (!$("#btnBid").prop("disabled") && $("#btnBid").data("lotID") && $("#btnBid").data("nextStep")) {
                var bidConv = self.formatOfferValue(parseFloat($("#btnBid").data("nextStep")) * self.currencyExchangeRatio, 2) + " " + self.settings.bidderCurrency;
                $("#btnBid .conv").html(bidConv).show();
            } else {
                $("#btnBid .conv").html("").hide();
            }

        } else {
            self.currencyExchangeRatio = 1;
            $('[data-display-offer="converted"]').hide();
            $("#btnBid .conv").html("").hide();
        }

    },
    configureAlternativeButton: function () {
        var self = this;
        if (self.settings.bidEnable != bidder.BOOL_TRUE) {
            if (self.settings.userID != null) {
                if (self.settings.bidderAuthStatus == bidder.UserAuthStatus.None.value) {
                    $("#btnBid").attr("href", self.options.registerToAuctionURL);
                    self.setBidButton(self.resources.RequestPaddle, bidder.ButtonStyle.Disabled.name, 0, 0);
                } else if (self.settings.bidderAuthStatus == bidder.UserAuthStatus.Pending.value) {
                    self.setBidButton(self.resources.PaddlePending, bidder.ButtonStyle.Disabled.name, 0, 0);
                } else if (self.settings.bidderAuthStatus == bidder.UserAuthStatus.Suspended.value) {
                    self.setBidButton(self.resources.PaddleSuspended, bidder.ButtonStyle.Disabled.name, 0, 0);
                } else if (self.settings.bidderAuthStatus == bidder.UserAuthStatus.Reject.value) {
                    self.setBidButton(self.resources.PaddleRejected, bidder.ButtonStyle.Disabled.name, 0, 0);
                }

            } else if (self.settings.userID == null) {
                //anonymous user                               
                $("#btnBid").attr("href", self.options.loginURL);
                self.setBidButton(self.resources.LoginToOffer, bidder.ButtonStyle.Disabled.name, 0, 0);
                // 2019-11-11 explicitly enable button with login link
                self.setBidButtonDisabled(false);
            }

        }
    },
    setBidButtonDisabled: function (disable) {
        var self = this;
        self.canPlaceBid = !disable;
        $("#btnBid").prop("disabled", disable);
    },
    setBidButton: function (text, styleName, lotID, value, onHoverText) {
        var self = this;
        var bidLotID = lotID || self.status.LotID;
        var bidValue = value || self.status.NextStep;
        styleName = styleName || bidder.ButtonStyle.Enabled.name;
        $("#btnBid").removeClass(bidder.ButtonStyle.Join()).addClass(styleName);
        $("#btnBid .text").html(text);
        $("#btnBid").data("lotID", bidLotID);
        $("#btnBid").data("nextStep", bidValue);
        $("#btnBid").data("default-text", text);
        $("#btnBid").data("onhover-text", onHoverText);
    },
    showLotCloseStatus: function (message, status) {
        var self = this;
        if (self.settings.useToastr) toastr.clear();
        self.showMessage(message, status);
    },
    showFairWarning: function () {
        var self = this;
        self.showMessage(self.resources.FairWarningMessage, bidder.LogType.Warning, null, 0);
        self.addHistory(self.resources.FairWarningMessage, bidder.HistMsgType.Warning, self.settings.historyOrder);
        self.setBidButton($('#btnBid .text').html(), bidder.ButtonStyle.FairWarning.name);
    },
    hideFairWarning: function () {
        var self = this;
        $("#btnBid").removeClass("-fair-warning");
        if (self.settings.useToastr) toastr.clear();
    },
    addHistory: function (text, type) {
        var self = this;
        type = type || bidder.HistMsgType.Info;
        if (text != self.lastMessage) {
            if (!self.options.historyOrder) {
                $('[data-display-history="list"]').prepend($('<li class="' + type.name + '">' + text + '</li>\n'));
            } else {
                $('[data-display-history="list"]').append($('<li class="' + type.name + '">' + text + '</li>\n'));
                $('[data-display-history="list"]').parent().scrollTop($('[data-display-history="list"]')[0].scrollHeight);
            }
            self.lastMessage = text;
        }
    },
    showMessage: function (message, type, title, timeOut) {
        var self = this;

        if (!self.settings.useToastr) {
            return;
        }

        console.log('showMessage', message, type, title, timeOut);
        var fontSize = '30px';
        var largeWidth = '480px', mediumWidth = '360px';
        type = type || bidder.LogType.Info;
        timeOut = (timeOut != null) ? timeOut : bidder.NotificationTimeout;
        var options = { timeOut: timeOut };
        var toastCurrent = null;
        switch (type.name) {
            case bidder.LogType.Warning.name:
                toastCurrent = toastr.warning(message, title, options);
                break;
            case bidder.LogType.Info.name:
                toastCurrent = toastr.info(message, title, options);
                break;
            case bidder.LogType.Error.name:
                toastCurrent = toastr.error(message, title, options);
                break;
            case bidder.LogType.Success.name:
                toastCurrent = toastr.success(message, title, options);
                break;
        }
        if (toastCurrent) {
            toastCurrent.css('font-size', fontSize).css('min-width', largeWidth);
        }
        return toastCurrent;
    },
    stopConnection: function () {
        var self = this;
        self.setBidButton(self.resources.AuctionSessionEnded, bidder.ButtonStyle.Disabled.name);
        self.showMessage(self.resources.AuctionSessionEnded, bidder.LogType.Warning, null, null);
        self.addHistory(self.resources.AuctionSessionEnded, bidder.HistMsgType.Warning);
        self.stopTryReconnection = true;
        $.connection.hub.stop();
    },
    dispatch: function (name, init) {
        var newEvent;
        try {
            newEvent = new CustomEvent(name, init)
        } catch (err) {
            newEvent = document.createEvent('CustomEvent')
            newEvent.initCustomEvent(
                name,
                init && typeof (init.bubbles) !== 'undefined' ? init.bubbles : true,
                init && typeof (init.cancelable) !== 'undefined' ? init.cancelable : false,
                init ? init.detail : null
            );
        }
        document.querySelector('body').dispatchEvent(newEvent);
    },
    formatOfferValue: function (value, n) {
        if (value && !isNaN(value)) {
            return value.toFixed(n).replace('.', ',').replace(/(\d)(?=(\d{3})+(,|$))/g, '$1.');
        }
        return value;
    },
};
